$(function(){

  function facilityNavHandler(container, items){
    // get needed values
    let $container = $(container);
    let containerWidth = $($container).outerWidth(true);
    let navBarDropdown = $(container).find('.navBarDropdown');
    let navBarDropdownWidth = navBarDropdown.outerWidth(true);

    let totalItmesWidth = 0;
    
    items.forEach((item, index) => {
      
      // with every item add to total width of current items
      totalItmesWidth += item.width;
      
      if ( item.isDropDownOnly || (totalItmesWidth >= (containerWidth - navBarDropdownWidth)) )
      {
        // if is dropdown only or item would be overlapping container
        // hide it in the menu and show it in the dropdown
        $container.find('.navBarItem').eq(index).addClass('d-none');
        navBarDropdown.find('.navBarDropdownItem').eq(index).removeClass('d-none');
      }
      else
      {
        // otherwise hide in in the dropdown and show it in the menu
        $container.find('.navBarItem').eq(index).removeClass('d-none');
        navBarDropdown.find('.navBarDropdownItem').eq(index).addClass('d-none');
      }

    });

    // if dropdown has any visible items, show it, otherwise hide
    if ( navBarDropdown.find('.navBarDropdownItem:not(.d-none)').length )
    {
      navBarDropdown.removeClass('d-none');
    }
    else
    {
      navBarDropdown.addClass('d-none');
    }
  }

  // for each navbar containers
  $('.navBarContainer').each(function(){

    let container = this;

    // get list of items, their widths and wheter it's only dropdown
    let items = [];

    $(this).find('.navBarItem').each(function(){
      let $item = $(this);

      items.push({
        width: $item.hasClass('DropDownOnly') ? 0 : $item.outerWidth(true),
        isDropDownOnly: $item.hasClass('DropDownOnly')
      });
    });


    // init on load
    facilityNavHandler(container, items);

    // init on resize, throttle the function call to save resources
    $(window).on('resize', function(){
      //facilityNavHandler(container, items);
      $(window).on('resize', throttleFacilityNav(facilityNavHandler, container, items, 500));
    });

    function throttleFacilityNav(callback, container, items, delay) {
      let timeoutHandler = null;
      return function () {
          if (timeoutHandler == null) {
              timeoutHandler = setTimeout(function () {
                  callback(container, items);
                  timeoutHandler = null;
              }, delay);
          }
      }
    }

    // show initted navbar
    $(this).removeClass('jsNavBarContainerHidden');
  });

});